import { useState, useEffect } from "react";

export const useCakeFormState = (cakeData = null, attributeOptions = {}) => {
  const initialState = {
    name: "",
    displayName: "",
    description: "",
    basePrice: "",
    category: "specialtyCake",
    searchableDescription: "",
    eventType: [],
    disclaimers: [],
    keywords: "",
    audience: [],
    popularity: 0,
    disclaimers: [],
    seo: { metaTitle: "", metaDescription: "", metaKeywords: "" },
    attributes: [],
    images: { primary: "", secondary: [] },
    isFeatured: false,
    isActive: true,
    flavors: [],
    sizes: [],
    customizationOptions: [],
    notes: "",
    imageFile: null,
  };

  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (cakeData) {
      setFormData({
        ...initialState,
        ...cakeData,
        flavors: Array.isArray(cakeData.flavors) ? cakeData.flavors : [],
        sizes: Array.isArray(cakeData.sizes) ? cakeData.sizes : [],
        disclaimers: Array.isArray(cakeData.disclaimers)
          ? cakeData.disclaimers
          : [],
        keywords: Array.isArray(cakeData.keywords)
          ? cakeData.keywords.join(", ")
          : typeof cakeData.keywords === "string"
          ? cakeData.keywords
          : "",
        eventType: Array.isArray(cakeData.eventType) ? cakeData.eventType : [],
        attributes: Array.isArray(cakeData.attributes)
          ? cakeData.attributes
          : [],

        images: cakeData.images ?? { primary: "", secondary: "" },
        imageFile: null,
      });
    }
  }, [cakeData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleKeywordsChange = (e) => {
    setFormData((prev) => ({ ...prev, keywords: e.target.value }));
  };

  const handleAttributeChange = (type, value) => {
    setFormData((prev) => {
      const current = prev.attributes.map(String);
      const toRemove = attributeOptions[type]?.map((a) => String(a._id)) || [];

      const filtered = current.filter((id) => !toRemove.includes(id));
      const merged = [...filtered, ...value.map(String)];

      return {
        ...prev,
        attributes: merged,
      };
    });
  };

  const handleDisclaimerChange = (e) => {
    setFormData((prev) => ({ ...prev, disclaimers: e.target.value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, imageFile: file }));
  };

  const resetForm = () => setFormData(initialState);

  return {
    formData,
    setFormData,
    handleChange,
    handleKeywordsChange,
    handleAttributeChange,
    handleDisclaimerChange,
    handleFileChange,
    resetForm,
    loading,
    setLoading,
    uploading,
    setUploading,
  };
};
